export const MEDIA = {
  GET: '/media?path={path}',
};
